module.exports = __webpack_public_path__ + "static/006.thumb-a635de19f8765cf234985fcd30668c02.jpg";